import { connect } from 'react-redux';

import ItemsTransactionsReport from './ItemsTransactionsReport';
import { getItemsTransactionsList } from './itemsTransactionsReportActions';
import { sendExportExcelRequest } from '../TransferringRequests/transferringRequestsActions';

const mapStateToProps = state => ({
  itemsTransactionsList: state.items.itemsTransactionsList,
  isLoading: state.items.isLoading,
  reportLoading: state.transferringRequests.reportLoading,
});

const mapDispatchToProps = dispatch => ({
  getItemsTransactionsList: () => dispatch(getItemsTransactionsList()),
  sendExportExcelRequest: (params, type) =>
    dispatch(sendExportExcelRequest(params, type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemsTransactionsReport);
